import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const PaymentTypeIdField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return <FullInfoField label="paymentTypeIdLabel" value={restaurantForFullInfo?.paymentTypeId} />;
};
